'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === undefined ? 0.5 : _ref$spacing,
      styles = _ref.styles;
  var rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      colors = _ref2.colors,
      fonts = _ref2.fonts,
      measures = _ref2.measures;

  var baseStyles = {
    root: {
      display: 'block',
      position: 'relative',
      fontFamily: fonts.body,
      textAlign: 'left',
      marginBottom: rhythm(1)
    },

    wrapper: {
      display: 'flex',
      flexWrap: 'nowrap',
      marginLeft: rhythm(-spacing)
    },

    input: {
      root: {
        flex: 'auto',
        marginBottom: 0,
        marginLeft: rhythm(spacing)
      },
      field: {
        textAlign: 'center'
      },
      label: {
        display: 'none'
      }
    }
  };

  return (0, _merge2.default)(baseStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-date/styles.js
// module id = 895
// module chunks = 0